import React from "react";
import filterConnect from "../../../../../../common/hoc/filterConnect";
import moment from "moment";
import {Skeleton} from "antd";

const RequestInfo = props => {
  const { request } = props;
  const requestType = request && request.requestTypeId;
  const requestView = request && request.requestViewId;
  return (
    <React.Fragment>
      {request && (
        <div className="offerCardSidebar">
          <div className="infoBar">
            <div className="infoGroup">
              <span className="name">Заявка</span>
              <span className="value">{requestType.requestType}</span>
            </div>
            <div className="infoGroup">
              <span className="name">Вид</span>
              <span className="value">{requestView.requestView}</span>
            </div>
            <div className="infoGroup">
              <span className="name">НДС</span>
              <span className="value">
                {request.nds
                  ? request.nds === 1
                    ? "С НДС"
                    : "Без НДС"
                  : "Не указан"}
              </span>
            </div>
            {request && request.arrivalDatetime && (
              <div className="infoGroup">
                <span className="name">Действует</span>
                <span className="value">
                  до {moment(request.arrivalDatetime).format("DD.MM.YYYY")}
                </span>
              </div>
            )}
            {request.serviceAdditional && request.serviceAdditional.length > 0 && (
              <div className="infoGroup">
                <span className="name">Доп. услуги</span>
                <div className="group">
                  {request.serviceAdditional.map(service => (
                    <span key={service.serviceAdditional} className="value">
                      {service.serviceAdditional}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      ) || <Skeleton active/>}
    </React.Fragment>
  );
};

export default filterConnect(RequestInfo, [
  "requestTypes",
  "requestViews",
  "paymentMethods"
]);
